<header id="shell">
    <tyt-nav #nav [limited]="true"></tyt-nav>
</header>
<div class="alert-spacer" *ngFor="let alert of alerts"></div>

<router-outlet></router-outlet>